import { useQuery } from 'convex/react';
import { api } from '@aeon-karaoke/cloud-convex';
import { useCurrentUser } from './useCurrentUser';

/** Tracks created this month against the plan limit, for the create flow. */
export function useMyTracksUsage() {
  const { user } = useCurrentUser();
  return useQuery(api.usage.thisMonth, user ? {} : 'skip');
}
